const longOrderedList = () =>{
    if(document.querySelector('ol.wp-block-list')){
        let allLists = document.querySelectorAll('ol.wp-block-list');
        Array.from(allLists).forEach(item =>{
            let listItems = item.querySelectorAll(':scope > li');
            let listLength = listItems.length ? listItems.length : 0;
            let startAttr = item.getAttribute('start');
            if(listLength > 99){
                item.classList.add('long-list')
            }
            if(listLength > 999){
                item.classList.add('very-long-list')
            }
            if(startAttr){
                let intAttr = parseInt(startAttr)
                if(intAttr + listLength > 99){
                    item.classList.add('long-list');
                }
                if(intAttr + listLength > 999){
                    item.classList.add('very-long-list');
                }

            }
        })
    }
}
export default longOrderedList;